import { Separator, H4 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { v4 } from 'uuid'
import { getLastPathElement } from '../../../util/StringUtil'
import { MrnLink } from '../../app/Links'
import DataView from '../../common/DataView'

export default function OwsDeletedInfo({ deletedDate, deleteChanges }) {
  const { t } = useTranslation()
  if (!deletedDate && (!deleteChanges || deleteChanges.length === 0)) {
    return null
  }

  return (
    <>
      <H4 size="H5" supplementary>
        {t('ows.deletedInfo.deletedOws', 'Deleted OWS')}
      </H4>
      {deleteChanges.map((deleteChange) => {
        const data = [
          {
            label: t('ows.deletedInfo.deletedDate', 'Deleted Date'),
            detail: deletedDate?.original,
          },
          {
            label: t('reasonType', 'Reason Type'),
            detail: getLastPathElement(deleteChange.reasonType),
          },
          {
            label: t('ows.deletedInfo.reasonDescription', 'Reason Description'),
            detail: deleteChange.reasonText,
          },
          {
            label: t('ows.deletedInfo.sourceSystemType', 'Source System Type'),
            detail: getLastPathElement(deleteChange.sourceSystemType),
          },
          {
            label: t('ows.deletedInfo.sourceTempleId', 'Source Temple ID'),
            detail: deleteChange.sourceTempleId,
          },
          {
            label: t('ows.deletedInfo.sourceWhoUSysId', 'Source Who USys ID'),
            detail: <MrnLink mrn={deleteChange.sourceWhoMrn} newTab />,
          },
        ]
        return <DataView key={v4()} data={data} />
      })}
      <Separator />
    </>
  )
}
